import React from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tr from "date-fns/locale/tr";
import enUS from "date-fns/locale/en-US";
import { useTranslation } from "react-i18next";


registerLocale("tr", tr);
registerLocale("en", enUS);
setDefaultLocale("tr");

const adjustTimezone = (date) => {
  let d;
  if(date) {
    d = new Date(date.setMinutes(date.getMinutes() - date.getTimezoneOffset())); 
  }
  return d;
}

export default function ReactDatePicker({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) {
  const { i18n } = useTranslation();

  return (
    <div className={"form-group col-md-" + (props.colNumber || 4)}>
      <label className="text-black font-w600">
        {props.required ? "*" : ""}
        {props.label}
      </label>
      <DatePicker
        {...field}
        {...props}
        locale={i18n.language}
        dateFormat="dd/MM/yyyy"
        name={field.name}
        className={"form-control"}
        selected={field.value}
        onChange={(val) => {
          setFieldValue(field.name, adjustTimezone(val));
          if (props.onChangeFunc) {
            props.onChangeFunc(adjustTimezone(val));
          }
        }}
        autoComplete="off"
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
      {errors[field.name] && (
        <span className="text-danger">
          <small>*{errors[field.name]}</small>
        </span>
      )}
    </div>
  );
}
